<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" modalClass="modal-md" @submit="submit">
        <template #title>
            <template v-if="permission && !readonly">
                {{ i18n('Edit {name}').replace('{name}', application.authorizationType?.code !== 'profiles' ?
                    i18n('Permission') : i18n('Profile')) }}
            </template>
            <template v-else-if="permission">
                {{ i18n('{name} Detail').replace('{name}', application.authorizationType?.code !== 'profiles' ?
                    i18n('Permission') : i18n('Profile')) }}
            </template>
            <template v-else>
                {{ i18n('Add {name}').replace('{name}', application.authorizationType?.code !== 'profiles' ?
                    i18n('Permission') : i18n('Profile')) }}
            </template>
        </template>

        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row g-2">
            <div class="col-12" v-if="application.authorizationType?.code === 'profiles'">
                <Field :required="true" :disabled="submitted" :customAutofocus="true" :label="i18n('Type')"
                    type="dictionary" rest="types/profiles" v-model="formData.profileType"
                    :errorMessage="errorMessages.profileType" />
            </div>
            <div class="col-12">
                <Field v-model="formData.code" :errorMessage="errorMessages.code" :label="i18n('Code')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12">
                <Field v-model="formData.name" :errorMessage="errorMessages.name" :label="i18n('Name')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'text'" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <template v-if="!readonly">
                    <div class="col text-start">
                        <button type="button" class="btn btn-danger" @click="hide">
                            {{ i18n('Cancel') }}
                        </button>
                    </div>
                    <div class="col text-end">
                        <button type="submit" class="btn btn-primary text-white" :disabled="submitted">
                            {{ i18n('Confirm') }}
                        </button>
                    </div>
                </template>
                <div class="col text-end" v-else>
                    <button type="button" @click="hide" class="btn btn-outline-dark btn-sm me-2">
                        {{ i18n('Close') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import api from "@/api.js";
import { duplicate, } from "@/tools/object.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    props: {
        application: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            permissionId: null,
            permission: null,
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
        };
    },
    emits: [
        'added',
        'created',
        'shown',
        'hidden',
        'created',
        'updated',
    ],
    computed: {
        readonly() {
            return this.permission
                && this.permission.acl?.update !== true;
        },
    },
    methods: {
        show(permissionId) {
            this.permissionId = permissionId;
            this.permission = null;
            this.load().then(() => {
                this.submitted = false;
                this.$refs['modal'].show();
                this.errorMessages = {};
                this.errorMessage = '';

                if (this.permission) {
                    this.formData = duplicate(this.permission);
                } else {
                    this.formData = {};
                }
            });
        },
        load() {
            if (!this.permissionId) return Promise.resolve();
            let promise = api.get(`applications/${this.application.id}/permissions/${this.permissionId}`, { acl: 'permission' });

            promise.then(permission => {
                this.permission = permission;
            });

            return promise;
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            this.errorMessages = {};
            this.errorMessage = '';

            const postFormData = duplicate(this.formData);
            let savePromise;

            if (!this.permission) {
                savePromise = api.post(`applications/${this.application.id}/permissions`, postFormData);
            } else {
                savePromise = api.put(`applications/${this.application.id}/permissions/${this.permission.id}`, postFormData);
            }

            api.clearCache();

            savePromise.then(permission => {
                if (!this.permission) {
                    this.$emit('created', permission);
                } else {
                    this.$emit('updated', permission);
                }

                api.clearCache();
                this.hide();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage);
                this.submitted = false;
            });
        }
    }
}
</script>